export const getMargin = (defaultUnitCost: number, productPriceUnitPrice: number) => {
    const unitPrice = productPriceUnitPrice > 0 ? productPriceUnitPrice : 0
    const unitCost = defaultUnitCost > 0 ? defaultUnitCost : 0
    if (unitPrice == 0 && unitCost == 0) {
        return 0
    } else {
        const profit = unitCost != 0 ? (unitPrice - unitCost) / unitCost : 1
        return isNaN(profit) ? 0 : Math.round(profit * 100)
    }
}

export const getMarginalUnitPrice = (defaultUnitCost: number, profitMargin: number) => {
    const unitCost = defaultUnitCost > 0 ? defaultUnitCost : 0
    const profit = profitMargin / 100
    const unitPrice = (profit + 1) * unitCost
    return Math.round(unitPrice * 100) / 100
}


// WEBPACK FOOTER //
// ./src/utils/margin/utils.ts